import React from 'react';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { BodyM } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/components/infoStyles';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IInfoRowProps {
	title?: string | React.ReactElement;
	value?: string | React.ReactElement;
	isHeader?: boolean;
	noBorder?: boolean;
}

const InfoRow = ({ title = '', value = '', isHeader, noBorder }: IInfoRowProps) => {
	const classes = useStyles();
	const isTitleString: boolean = typeof title === 'string';
	const isValueString: boolean = typeof value === 'string';
	const isNumbersAffected: boolean = title === 'Numbers affected';

	return (
		<div
			className={classNames(classes.infoRowContainer, {
				[classes.border]: !isHeader && !noBorder,
				[classes.numbersAffected]: isNumbersAffected,
			})}
		>
			<ConditionalRender
				show={isTitleString}
				onTrue={() => <BodyM color="disabled-light">{title}</BodyM>}
				onFalse={() => <div>{title}</div>}
			/>
			<ConditionalRender
				show={isValueString}
				onTrue={() => <BodyM color={isHeader ? 'disabled-light' : undefined}>{value}</BodyM>}
				onFalse={() => <div>{value}</div>}
			/>
		</div>
	);
};

export default InfoRow;
